export const MINIMUM_AMOUNT = 5000;
